import { render } from "./ProviderSummaryCard.vue?vue&type=template&id=3158ee49&scoped=true&ts=true"
import script from "./ProviderSummaryCard.vue?vue&type=script&lang=ts"
export * from "./ProviderSummaryCard.vue?vue&type=script&lang=ts"

import "./ProviderSummaryCard.vue?vue&type=style&index=0&id=3158ee49&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3158ee49"]])

export default __exports__